import { IButtonProps } from "@/template/components/Button/index.tsx";
import * as S from "./styles.ts";
import useLink from "@/lib/helpers/useLink.ts";
import { DynamicIcon } from "@/template/components/index.ts";

interface IExtendedButtonProps extends IButtonProps {
  icon?: string;
  hasEffect?: boolean;
  flipText?: boolean;
}

const FlipButton = ({
  variant = "solid",
  color = "primary",
  size = "sm",
  children,
  navigation,
  href,
  ignoreHref,
  icon,
  hasEffect = false,
  flipText,
  ...props
}: IExtendedButtonProps) => {
  const link = useLink();

  return (
    <S.FlipButtonContainer
      onClick={(e) => {
        if ((navigation?.href || href) && !ignoreHref) {
          link({
            href: navigation?.href ? navigation.href : (href as string),
            target: navigation?.target || "_self",
          });
        }
      }}
      {...props}
    >
      <S.FlipButtonInner>
        {/* Front Face */}
        <S.FlipButtonFront
          $variant={variant}
          $color={color}
        >
          {icon && <DynamicIcon name={icon} />}
          {children}
        </S.FlipButtonFront>

        {/* Back Face */}
        <S.FlipButtonBack
          $variant={variant}
          $color={color}
        >
          {icon && <DynamicIcon name={icon} />}
          {flipText}
        </S.FlipButtonBack>
      </S.FlipButtonInner>
    </S.FlipButtonContainer>
  );
};

export default FlipButton;
